// Primitive 6 — Tabs.
// De vrais `<button role="tab">`, navigables au clavier (flèches,
// Origine, Fin) — pas des <div> stylés.

import { useRef } from 'react';

export function Tabs({ tabs, value, onChange, label = 'Sections' }) {
  const refs = useRef([]);

  function onKeyDown(e) {
    const index = tabs.findIndex((t) => t.value === value);
    let next = null;
    if (e.key === 'ArrowRight') next = (index + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = tabs.length - 1;
    if (next === null) return;
    e.preventDefault();
    onChange(tabs[next].value);
    refs.current[next]?.focus();
  }

  return (
    <div className="tabs" role="tablist" aria-label={label}>
      {tabs.map((tab, i) => (
        <button
          key={tab.value}
          ref={(el) => {
            refs.current[i] = el;
          }}
          type="button"
          onKeyDown={onKeyDown}
          role="tab"
          className="tabs__tab"
          aria-selected={tab.value === value}
          tabIndex={tab.value === value ? 0 : -1}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
